/**
 * File: form-toolkit.js
 *
 * Import and initialize functions for the Form Toolkit
 */

 export default {
	forms: document.querySelectorAll('.ngp-form'),
	init() {
		if (this.forms) {
			this.render();
		}
	},
	render() {
		this.forms.forEach(form => {
			if (form.querySelector('.ngp-form-note')) {
				form.querySelector('.ngp-form-note').remove();
			}
		});

		const restructureForms = () => {
			const inputs = document.querySelectorAll('.at-text, .at-select');

			inputs.forEach(el => {
				const small = el.querySelector('small');
				if (small) {
					small.remove();
				}
				const input = el.querySelector('input[type="text"]') || el.querySelector('input[type="tel"]') || el.querySelector('input[type="email"]');
				const select = el.querySelector('select');
				const telWithCountryInput = el.querySelector('.intl-tel-input');

				if (telWithCountryInput) {
					const previousElement = telWithCountryInput.previousSibling;
					if (!previousElement || previousElement.nodeName !== '#text') return;
					const text = previousElement.textContent;
					previousElement.remove();
					const input = telWithCountryInput.querySelector('input');
					input.placeholder = text;
				}

				if (input) {
					const previousElement = (el.querySelector('input') && el.querySelector('input').previousSibling);
					if (!previousElement || previousElement.nodeName !== '#text') return;
					const text = previousElement.textContent;
					previousElement.remove();
					input.placeholder = text;
				}

				if (select) {
					let previousElement;
					if (el.querySelector('.select_container')) {
						previousElement = el.querySelector('.select_container').previousSibling;
					}

					else {
						previousElement = el.querySelector('select') && el.querySelector('select').previousSibling
					}

          const handleChange = (event) => {
            if (event.currentTarget.value === '') {
              event.currentTarget.classList.add('not-selected');
            } else {
              event.currentTarget.classList.remove('not-selected');
            }
          }
      
          select.addEventListener('change', handleChange);
          select.classList.add('not-selected');

					if (!previousElement || previousElement.nodeName !== '#text') return;
					const text = previousElement.textContent;
					previousElement.remove();

					if (select.hasAttribute('multiple')) {
						const input = el.querySelector('input');
						input.placeholder = text;
					}
					else {
						const firstOption = select.querySelector('option:first-of-type');
						firstOption.innerHTML = text;
					}
				}
			});
		}

		if (!document.querySelector(".ngp-form")) return;

		window.onload = function () {
			setTimeout(() => {
				restructureForms();
			}, 1000);
		}

		const observer = new MutationObserver(function (mutationsList) {
			mutationsList.forEach(function (mutation) {
				const classList = mutation.target.getAttribute("class") || '';
				if (classList.includes('at-form')) {
					restructureForms();
    
				}
			});
		});

		observer.observe(document.querySelector(".ngp-form"), { subtree: true, childList: true })
	},
};
